import { ReactElement } from 'react';
import { Tooltip } from 'antd';
import { BulkCreateAdvisorsResult } from '@minutes-system/backend/src/api/advisors/schema';
import { SuccessIcon } from '../../../../../components/SuccessIcon';
import { ErrorIcon } from '../../../../../components/ErrorIcon';
import { WarningIcon } from '../../../../../components/WarningIcon';

interface Props {
  result?: BulkCreateAdvisorsResult;
}

const getReasonText = (reason: string): string => {
  const reasonMap: Record<string, string> = {
    // 警告
    'same-name-exists': '同姓同名の営業担当者が既に存在します',
    // エラー
    'exact-duplicate': '完全に同一のレコードが既に存在します',
    'name-changed': '氏名変更の可能性があります',
  };
  return reasonMap[reason] ?? reason;
};

const getTooltipContent = (result: BulkCreateAdvisorsResult): string | null => {
  switch (result.resultType) {
    case 'success':
      return null;
    case 'success-with-warning': {
      const reasonText = getReasonText(result.reason);
      const existingInfo = result.existingRecords.map(r => `${r.name} (電話番号: ${r.phone})`).join(', ');
      return `${reasonText}\n既存レコード: ${existingInfo}`;
    }
    case 'error-input-duplicate': {
      const rowNumbers = result.duplicateRows.map(r => `${String(r.rowNumber)}行目`).join(', ');
      return `${rowNumbers}と重複しています`;
    }
    case 'error-existing-duplicate': {
      const reasonText = getReasonText(result.reason);
      const existingInfo = result.existingRecords.map(r => `${r.name} (電話番号: ${r.phone})`).join(', ');
      return `${reasonText}\n既存レコード: ${existingInfo}`;
    }
  }
};

const ResultIcon = ({ result }: Props): ReactElement | null => {
  if (result === undefined) {
    return null;
  }

  switch (result.resultType) {
    case 'success': {
      return <SuccessIcon />;
    }
    case 'success-with-warning': {
      return (
        <Tooltip title={getTooltipContent(result)} placement='left'>
          <WarningIcon />
        </Tooltip>
      );
    }
    case 'error-input-duplicate':
    case 'error-existing-duplicate': {
      return (
        <Tooltip title={getTooltipContent(result)} placement='left'>
          <ErrorIcon />
        </Tooltip>
      );
    }
  }
};

export default ResultIcon;
